import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SenderId } from '../user-info-config/user-info-config.service';


@Injectable({
  providedIn: 'root'
})
export class SenderStateService {
  private currentSenderSubject = new BehaviorSubject<SenderId | null>(null);
  currentSender$ = this.currentSenderSubject.asObservable();

  constructor() {
    const storedSender = localStorage.getItem('currentSender');
    if (storedSender) {
      this.currentSenderSubject.next(JSON.parse(storedSender));
    }
  }

  setCurrentSender(sender: SenderId) {
    localStorage.setItem('currentSender', JSON.stringify(sender));
    this.currentSenderSubject.next(sender);
  }

  getCurrentSender(): SenderId | null {
    return this.currentSenderSubject.getValue();
  }

  clearCurrentSender() {
    localStorage.removeItem('currentSender');
    this.currentSenderSubject.next(null);
  }
}